import React from 'react'
import { ResponsiveLayout } from 'containers'
import { ProfileWithRollout } from './ProfileWithRollout'
import Header from 'containers/ResponsiveLayout/Header'

export const ProfileMobileWrapper = () => {
  return (
    <ResponsiveLayout
      menu={<Header />}
      content={
        <div style={{ padding: '0 16px 8px' }}>
          <ProfileWithRollout />
        </div>
      }
    />
  )
}
